import { CommonModule, NgIf } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { SambaUploderService } from "../samba-uploader/samba-uploader.service";

@Component({
    selector  : 'upload-snack',
    standalone: true,
    imports   : [CommonModule, MatProgressBarModule, MatButtonModule, MatIconModule],
   template  : `
    <!-- FAB  -->
    <button *ngIf="minimized"
            class="mini-toggle"
            mat-fab
            color="primary"
            aria-label="Expandir upload"
            (click)="toggle()">
      <mat-icon>expand_less</mat-icon>
    </button>

    <div *ngIf="!minimized" class="wrapper">

      <!-- ERRO -->
      <ng-container *ngIf="error">
        <div class="bar error">
          <mat-icon>error</mat-icon>
          <span>Falha no upload</span>

          <button mat-icon-button class="close" (click)="close()"
                  aria-label="Fechar"><mat-icon>close</mat-icon></button>
        </div>
      </ng-container>

      <!-- PROGRESSO -->
      <ng-container *ngIf="!error && pct < 100">
        <div class="bar">
          <mat-progress-bar mode="determinate" [value]="pct"></mat-progress-bar>
          <span>{{ pct }}%</span>

          <button mat-icon-button class="close" (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
          <button mat-icon-button class="mini" (click)="toggle()">
            <mat-icon>remove</mat-icon>
          </button>
        </div>
        <small class="warn">Não feche a página durante o upload</small>
      </ng-container>

      <!-- LOADER FINAL -->
      <ng-container *ngIf="!error && pct === 100 && waiting">
        <div class="bar">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <span>Preparando upload…</span>

          <button mat-icon-button class="close" (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
          <button mat-icon-button class="mini" (click)="toggle()">
            <mat-icon>remove</mat-icon>
          </button>
        </div>
      </ng-container>

      <!-- PREVIEW -->
      <ng-container *ngIf="!error && pct === 100 && !waiting">
        <button mat-raised-button color="accent"
                class="preview" (click)="goPreview()">
          <mat-icon class="me-1">visibility</mat-icon>
          Upload do conteúdo foi concluído
        </button>
        <button mat-icon-button class="close" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
        <button mat-icon-button class="mini" (click)="toggle()">
          <mat-icon>remove</mat-icon>
        </button>
      </ng-container>

    </div>
  `,
  styles   : [`
    :host  {
       display:block; 
       font-family:Roboto, sans-serif; 
      }
    .wrapper { 
      width:100%; 
      max-width:none; 
    }

    .bar{
      display:flex; 
      align-items:center; 
      gap:8px; 
      position:relative;
    }

    .bar mat-progress-bar{ 
      flex:1 1 auto; 
      min-width:0; 
    }
    .bar span { margin-left:4px; }

    .close, .mini{
      order:1;
      margin-left:auto; 
      flex:0 0 24px;
    }

    .warn { 
      color:#ffc107; 
      font-size:11px; 
    }
    .preview { font-weight:600; }

    .bar.error{
      background:#d32f2f; 
      color:#fff; 
      padding:8px 12px; 
      border-radius:4px;
    }
    .bar.error mat-icon{ margin-right:4px; }

    .mini-toggle{
      position:fixed; 
      bottom:24px; 
      right:24px; 
      z-index:1000;
      pointer-events: auto;
    }

    :host.minimized .wrapper{ display:none; }
  `]
})
export class UploadSnackComponent implements OnInit, OnDestroy, AfterViewInit {

  pct = 0;

  waiting   = false;
  private timerStarted = false;

  minimized = false;
  @HostBinding('class.minimized') get isMin(){ return this.minimized; }
  private snackbarContainer: HTMLElement;

  error = false;
  private errSub!: Subscription;

  constructor(
    private router: Router,
    private ref: MatSnackBarRef<UploadSnackComponent>,
    private cdr: ChangeDetectorRef,
    private uploader: SambaUploderService,            
    @Inject(MAT_SNACK_BAR_DATA) public data: { contentId:number },
    private elementRef: ElementRef<HTMLElement>
  ) {
  }

  ngAfterViewInit(): void {
    this.snackbarContainer = this.elementRef.nativeElement.closest('.mat-snack-bar-container')
  }

  ngOnInit(){
    this.errSub = this.uploader.isError$()
      .subscribe(e => { this.error = e; this.cdr.markForCheck(); });
  }
  ngOnDestroy(){ this.errSub?.unsubscribe(); }

  update(v:number){
    this.pct = v;
    if (v === 100 && !this.timerStarted){
      this.timerStarted = true;
      this.startDelay();
    }
  }

  private startDelay(){
    this.waiting = true; this.cdr.markForCheck();
    setTimeout(()=>{
      this.waiting = false; this.cdr.markForCheck();
    }, 20_000);          
  }

  toggle(){ 
      this.minimized = !this.minimized; 
      if(this.minimized) {
        this.snackbarContainer.classList.add('snackbar-container-minimized')
      } else {
        this.snackbarContainer.classList.remove('snackbar-container-minimized')
      }
  }

  goPreview(){
    this.router.navigate(
      ['/gestao/conteudo/editar', this.data.contentId, 'arquivos']
    ).then(() => this.ref.dismiss());
  }

  close(){ this.ref.dismiss(); }
}